<template>
    <div>
        <div>
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
                    <v-tabs v-if="tabForm" :type="2" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm">
                        <template slot="tabs" slot-scope="scope">
                            <!-- 主要信息 -->
                            <div v-if="scope.index == 0">
                                <el-form label-width="150px" id="mainInfo" class="baseForm" :show-message="false" :model="sendDataInfo" ref="sendDataInfo" size="mini">
                                    <el-row v-if="actionData.cate != 2">
                                        <el-form-item label="" v-if="formOneValue.isShow == 1" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey"
                                                      :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                                            <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField) + ':'"></label>
                                            <!-- 检索方案 -->
                                            <el-tooltip v-if="formOneValue.fieldType == 'search'" class="item"
                                                        :disabled="(sendDataInfo[formOneValue.entityField] == null || sendDataInfo[formOneValue.entityField] == '' ? true : false) || sendDataInfo[formOneValue.entityField].length <= 9"
                                                        effect="dark" :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                                                <el-input clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                          @keyup.enter.native="openSearch(formOneValue.searchId, formOneValue.isIndex, formOneValue.entityField, formOneValue.setField, formOneValue.focusField)"
                                                          :disabled="formOneValue.isChange == 0">
                                                    <el-button @click="openSearch(formOneValue.searchId, formOneValue.isIndex, formOneValue.entityField, formOneValue.setField, formOneValue.focusField)" slot="append"
                                                               icon="el-icon-search" :disabled="formOneValue.isChange == 0">
                                                    </el-button>
                                                </el-input>
                                            </el-tooltip>
                                            <!-- 日期 -->
                                            <df-date v-else-if="formOneValue.fieldType == 'date'" v-model="sendDataInfo[formOneValue.entityField]"
                                                     @keyup.enter.native="nextFocus(formOneValue.isIndex, formOneValue.focusField)" :isShowLong="false" :isdisabled="formOneValue.isChange == 0">
                                            </df-date>
                                            <el-select clearable size="mini" v-else-if="formOneValue.fieldType == 'formatter'" @visible-change="selectChange" :disabled="formOneValue.isChange == 0"
                                                       @change="$forceUpdate()" v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                                                <el-option v-for="item in JSON.parse(formOneValue.formatterContent)" :key="item.key" :label="item.key" :value="item.value">
                                                </el-option>
                                            </el-select>
                                            <el-input @keyup.enter.native="nextFocus(formOneValue.isIndex, formOneValue.focusField)" v-else :disabled="formOneValue.isChange == 0"
                                                      v-model.trim="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength"></el-input>
                                        </el-form-item>
                                    </el-row>
                                    <el-row v-else>
                                        <el-form-item label="" v-if="formOneValue.isShow == 1" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey"
                                                      :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                                            <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField) + ':'"></label>
                                            <span v-if="formOneValue.isRift == 1">
                                                <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{
                                       sendDataInfo[formOneValue.entityField]
                                    }}</a>
                                            </span>
                                            <span v-else-if="formOneValue.fieldType == 'date'">
                                                <span v-if="sendDataInfo[formOneValue.entityField]">
                                                    {{ $common.getLocalTime(sendDataInfo[formOneValue.entityField])
                                       }}
                                                </span>
                                            </span>
                                            <span v-else-if="formOneValue.entityField == 'isWms'">{{
                                    sendDataInfo.isWms == 1 ?
                                       '是' : '否' }}</span>
                                            <span v-else-if="formOneValue.fieldType == 'formatter'">{{
                                    getValue(sendDataInfo[formOneValue.entityField],
                                       formOneValue.entityField, formOneValue.fieldType,
                                       formOneValue.formatterContent) }}</span>
                                            <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                                        </el-form-item>
                                    </el-row>
                                </el-form>
                                <!-- 明细 -->
                                <el-form :inline="true" size="mini">
                                    <el-table v-if="mxForm" size="mini" ref="mxTableRef" id="mxTable" :data="sendDataInfo.consumeDetailVoList" border style="width: 100%;margin-bottom:10px;" :height="mxHeight">
                                        <el-table-column v-if="formOneValue.isShow == 1" align="center" v-for="(formOneValue, tableKey) in mxForm.jurconfigform" :key="tableKey" :prop="formOneValue.entityField"
                                                         :label="formOneValue.showField" show-overflow-tooltip :min-width="formOneValue.fieldWeight">
                                            <template slot-scope="scope">
                                                <!-- 含税价格 -->
                                                <el-input v-if="formOneValue.entityField == 'psprice' && actionData.cate != 2" type="number"
                                                          v-model.trim="sendDataInfo.consumeDetailVoList[scope.$index][formOneValue.entityField]" @input="calculatePrice(1, scope.$index)"></el-input>
                                                <span v-else-if="formOneValue.fieldType == 'date'">
                                                    <span v-if="scope.row[formOneValue.entityField]">
                                                        {{ $common.getLocalTime(scope.row[formOneValue.entityField]) }}
                                                    </span>
                                                </span>
                                                <span v-else>{{ scope.row[formOneValue.entityField] }}</span>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </el-form>
                            </div>
                        </template>
                    </v-tabs>
                </el-card>
                <v-foot :actionType="actionData.cate" :footForm="footForm" :btnFlag="false" :sendDataInfo="sendDataInfo" @initActionBox="initActionBox" @sendDataAction="sendDataAction"
                        @showPrintPlan="showPrintPlan"></v-foot>
            </div>
        </div>
        <printPlan ref="printPlan"></printPlan>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" append-to-body>
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
    </div>
</template>

<script>
import NP from "number-precision";
export default {
    name: "consumePriceAction",
    props: ["actionData"],
    data() {
        return {
            mxHeight: 300,
            dataActionBox: {
                actionType: 2
            },
            showTabs: "",
            selectDataIndex: 0,
            inputel: "", //所有input对象
            formDataList: [],
            tabForm: [], // tab循环的主表单
            mxForm: [],
            footForm: [],
            sendDataInfo: {},
            //------------
            DialogVisible: false,
            seWidth: "",
            seTitle: "",
            seId: "",
            seIndex: 0,
            sField: "", // 赋值字段
            fField: "", //焦点字段
            seType: "",
            parentSearchData: {},
        }
    },
    watch: {
        "sendDataInfo.worcmCheckName"() {
            if (this.sendDataInfo.worcmCheckName == "") {
                this.sendDataInfo.worcmChecker = ""
            }
        },
        "sendDataInfo.consumeDetailVoList": {
            handler: function (newValue) {
                console.log(newValue);

                this.sendDataInfo.totalMoney = 0
                this.sendDataInfo.totalNumber = 0
                this.sendDataInfo.totalCount = 0
                this.sendDataInfo.totalGprofit = 0
                this.sendDataInfo.costTotalMoney = 0
                if (newValue.length > 0) {
                    newValue.forEach((values, keys) => {
                        this.$set(values, 'psprice', this.$common.updataNum('psprice', values).psprice)
                        this.sendDataInfo.totalMoney = this.$common.getDecimalInfo(3, NP.plus(this.sendDataInfo.totalMoney, values.psmoney || 0));
                        this.sendDataInfo.totalNumber = this.$common.getDecimalInfo(1, NP.plus(this.sendDataInfo.totalNumber, values.num || 0));
                        this.sendDataInfo.totalGprofit = this.$common.getDecimalInfo(3, NP.plus(this.sendDataInfo.totalGprofit, values.gross || 0));
                        this.sendDataInfo.costTotalMoney = this.$common.getDecimalInfo(3, NP.plus(this.sendDataInfo.costTotalMoney, values.costMoney || 0));
                    })
                    this.sendDataInfo.totalCount = newValue.length
                }

            },
            deep: true,
        }
    },
    created() {
        this.$nextTick(() => {
            this.openBox();
        });
    },
    methods: {
        getValue(val, type, fieldType, arr) {
            var str = ""
            if (type == 'bgiType' || fieldType == 'formatter') {
                if (arr) {
                    JSON.parse(arr).forEach(item => {
                        if (String(Number(item.value)) != NaN && item.value == val) {
                            str = item.key
                        } else if (String(Number(item.key)) != NaN && item.key == val) {
                            str = item.value
                        }
                    })
                }
            } else {
                str = val || ""
            }
            return String(str)
        },
        // 子组件穿透方法
        toDetail(orderId) {
            if (this.dataActionBox.actionType != 2)
                this.$parent.$parent.toDetail(orderId);
            else this.$parent.$parent.$parent.toDetail(orderId);
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },
        // 检索Id, 索引(表格中), 标识
        //        检索Id, 索引， 字段名，赋值字段，焦点字段, 不可赋值字段
        openSearch(sId, index, type, sField, fField,) {
            console.log(sId, index, type, sField, fField);
            this.DialogVisible = true;
            this.seId = sId;
            this.seIndex = index;
            this.seType = type;
            this.sField = sField;
            this.fField = fField;
            this.parentSearchData[type] = this.sendDataInfo[type];
        },
        //检索带回数据,
        changeInputModel(val) {
            console.log(val, this.seType);
            if (val != "" || val != undefined) {
                this.paramValue(val);
            }
            this.DialogVisible = false;
        },
        paramValue(val) {
            var arr = this.sField.split(",");
            arr.forEach(item => {
                this.sendDataInfo[item] = val[item];
            })
        },
        openBox() {
            this.formDataList = JSON.parse(JSON.stringify(this.actionData.formData))
            this.filterMainField()
            var dataInfo = JSON.parse(JSON.stringify(this.actionData.oldData))
            Object.keys(this.sendDataInfo).forEach(key => {
                if (dataInfo[key] != null && dataInfo[key] != undefined && dataInfo[key] != '' && dataInfo[key] != 0) {
                    this.$set(this.sendDataInfo, key, dataInfo[key])
                }
            })
            if (this.sendDataInfo.consumeDetailVoList.length > 0) {
                this.sendDataInfo.consumeDetailVoList.forEach((values, keys) => {
                    this.calculatePrice(1, keys)
                })
            }

            this.$nextTick(() => {
                setTimeout(() => {
                    this.mxHeight = this.$common.getBtnHeight()
                    this.initFocus();
                }, 16.7)
            });
        },
        calculatePrice(cate, index) {
            var info = this.sendDataInfo.consumeDetailVoList[index]
            switch (cate) {
                case 1:
                    // 计算含税金额 含税价格*数量
                    info.psmoney = info.num === 0 ? 0 : this.$common.getDecimalInfo(3, NP.times(info.psprice, info.num));
                    // 计算金额 含税金额/(税率/100+1)
                    var midmoney = this.$common.getDecimalInfo(3, NP.divide(info.psmoney, NP.plus(NP.divide(info.outRate, 100), 1)));
                    info.money = this.$common.getDecimalInfo(3, midmoney);
                    // 计算单价 金额/数量
                    info.price = info.num === 0 ? 0 : this.$common.getDecimalInfo(2, NP.divide(midmoney, info.num));
                    //计算税额 = 含税金额-金额
                    info.taxAmount = this.$common.getDecimalInfo(3, NP.minus(info.psmoney, info.money));
                    // 含税毛利 = 含税金额 - 成本含税金额
                    info.gross = this.$common.getDecimalInfo(3, NP.minus(info.psmoney, info.costMoney));
                    // 不含税毛利 = 金额 - 成本金额
                    info.taxgross = this.$common.getDecimalInfo(3, NP.minus(info.money, info.costAmount));
                    //毛利率 = 含税毛利/含税金额
                    info.grossProfit = info.psmoney != 0 ? this.$common.getDecimalInfo(2, NP.divide(info.gross, info.psmoney)) : 0;
                    break;

                default:
                    break;
            }
        },
        initActionBox() {
            this.$emit("drawerCancel");
        },
        sendDataAction(val) {
            this.$refs[val].validate(valid => {
                if (valid) {
                    this.submitValidData();      
                } else {
                    this.$message.error("请填写必填项！");
                }
            });
        },

        async submitValidData() {
            let sendData = JSON.parse(JSON.stringify(this.sendDataInfo));
            sendData.detailList = sendData.consumeDetailVoList
            delete sendData.consumeDetailVoList;
            let res = await this.$http.consumeAdminPriceIntercept(
                sendData
            );
            if (res.status == 200) {
                this.submitData();
            } else if (res.status == 300) {
                this.$confirm(res.message, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }).then(() => {
                    this.submitData();
                }).catch(() => {
                });
            }else{
                this.$message.error(res.message)
            }
        },

        async submitData() {
            let sendData = JSON.parse(JSON.stringify(this.sendDataInfo));
            sendData.detailList = sendData.consumeDetailVoList
            delete sendData.consumeDetailVoList;
            const res = await this.$http.consumeAdminfillPrice(sendData)
            if (res.status == 200) {
                this.$message.success(res.message)
                this.$emit("drawerCancel", true);
            } else {
                this.$message.error(res.message)
            }
        },
        showPrintPlan() { },
        // 获取主表单所有input
        getMainInput() {
            var el = document.getElementById("mainInfo");
            if (el) this.inputel = el.getElementsByTagName("input");
        },
        // 主表单select框切换enter切换焦点事件方法
        selectChange(e) {
            if (e == false) {
                for (let index = 0; index < this.inputel.length; index++) {
                    if (this.inputel[index] == document.activeElement) {
                        this.nextFocus(index);
                        break;
                    }
                }
            }
        },

        // 输入框切换焦点
        nextFocus(index, fField) {
            if (index >= this.inputel.length - 1) {
                if (this.sendDataInfo.consumeDetailVoList.length > 0) {
                }
                return;
            }
            if (fField == "keydown") {
                return;
            }
            var aindex = index + 1;
            if (
                this.inputel[aindex].value != "" ||
                this.inputel[aindex].disabled
            ) {
                this.nextFocus(aindex);
                return;
            }
            this.$nextTick(() => {
                this.inputel[aindex].focus();
            });
        },

        // 初始化焦点
        initFocus() {
            for (let index = 0; index < this.inputel.length; index++) {
                if (this.inputel[index].value == "") {
                    this.inputel[index].focus();
                    break;
                }
            }
        },
        // 过滤表单不同类型
        filterMainField() {
            var mainFormList = [];
            this.formDataList.forEach((item) => {
                if (item.jciType == 1) {
                    mainFormList.push(item);
                } else if (item.jciType == 2) {
                    this.mxForm = JSON.parse(JSON.stringify(item));
                } else if (item.jciType == 3) {
                    this.footForm = JSON.parse(JSON.stringify(item.jurconfigform));
                }
            });
            mainFormList.forEach((key, i) => {
                this.tabForm[i] = JSON.parse(JSON.stringify(key));
                this.tabForm[i].jurconfigform = [];
                var index1 = 0
                for (let index = 0; index < key.jurconfigform.length; index++) {
                    // if (key.jurconfigform[index].isShow == 1)
                    if (key.jurconfigform[index].isShow == 1) {
                        key.jurconfigform[index].isIndex = index1
                        index1++
                    }
                    this.tabForm[i].jurconfigform.push(key.jurconfigform[index]);

                }
            });
            this.showTabs = this.tabForm[0].jurName
            var arr = [{ entityField: "consumeDetailVoList" }];
            var obj = this.$common.filterMainFields(
                this.formDataList,
                arr,
                mainFormList[0]
            );
            for (let key in obj) {
                this.$set(this.sendDataInfo, key, obj[key]);
            }
            console.log(this.sendDataInfo, "测试");

        },
    },
}
</script>

<style scoped>
.foot1 {
    display: flex;
    /* justify-content: center; */
    align-items: center;
    width: 100%;
    background: #fff;
    height: 46px;
    padding: 5px 10px;
    z-index: 999;
    position: fixed;
    bottom: 0;
    left: 0;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
}

.sureButton {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
}

.number {
    color: red;
    font-size: 18px !important;
    background: none;
    border: none;
}

::v-deep .el-alert {
    width: 100%;
    height: 30px;
    line-height: 30px;
    padding: 0 !important;
    font-weight: 700;
    font-size: 16px;
}
</style>